const SlotConfigurationConstants = {
  defaultValue: {
    slots: [],
  },
};

module.exports = { SlotConfigurationConstants };
